// Calculations (AKA pure functions) outputting strings

import buildAssetsUrl from "./buildAssetsUrl";
import convertTz from "./convertTz";
import countDown from "./countDown";
import uuidFromUrl from "./uuidFromUrl";
import formatNumber from "./formatNumber";
import hyphenateList from "./hyphenateList";
import uuidToUrl from "./uuidToUrl";
import fileNameFromUrl from "./fileNameFromUrl";
import bumpVersion from "./bumpVersion";
import dualCurrencyString from "./dualCurrencyString";
import getReceiptLabel from "./getReceiptLabel";

export const StringUtils = {
  buildAssetsUrl,
  convertTz,
  countDown,
  uuidFromUrl,
  formatNumber,
  hyphenateList,
  uuidToUrl,
  fileNameFromUrl,
  bumpVersion,
  dualCurrencyString,
  getReceiptLabel,
};
